import * as PIXI from "pixi.js"

// PIXI.settings.ROUND_PIXELS = true
PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST
PIXI.settings.RESOLUTION = 2

export default PIXI
